export default (selectId) => {
  window.dispatchEvent(
    new CustomEvent('itemSelect', { detail: { id: selectId } })
  );
};
